'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _datepickerButton = require('./datepicker-button');

var _datepickerButton2 = _interopRequireDefault(_datepickerButton);

var _datepickerLocal = require('./datepicker.local.css');

var _datepickerLocal2 = _interopRequireDefault(_datepickerLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Last30Days = function Last30Days(props) {
  var display = props.display,
      setPeriod = props.setPeriod,
      active = props.active;

  if (!display) {
    return null;
  }

  return _react2.default.createElement('div', {
    className: _datepickerLocal2.default.t30Container
  }, _react2.default.createElement(_datepickerButton2.default, {
    active: active,
    onClick: function onClick() {
      return setPeriod('selected', 't30', {
        t30: true
      });
    }
  }, 'Last 30 Days'));
};

Last30Days.propTypes = {
  display: _propTypes2.default.bool,
  active: _propTypes2.default.bool,
  setPeriod: _propTypes2.default.func.isRequired
};
exports.default = Last30Days;